import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DataHexagon from '@backrs_ui/common-ui/src/assets/images/data-hexagon.svg';
import { Card, CardContent, Box, Typography, Checkbox } from '@mui/material';
export function DataLockedAndLoadedCard(_a) {
    var title = _a.title, description = _a.description, _b = _a.checkboxItems, checkboxItems = _b === void 0 ? [] : _b;
    return (_jsxs(Card, { sx: cardContainer, children: [_jsx(Box, { sx: cardTopSx, children: _jsx(Box, { sx: headerImageSx, children: _jsx("img", { src: DataHexagon, alt: "Header" }) }) }), _jsxs(CardContent, { sx: contentContainer, children: [_jsxs(Box, { sx: cardTitleContainer, children: [_jsx(Typography, { variant: "text-lg-semibold", children: title }), _jsx(Typography, { variant: "text-sm-regular", children: description })] }), _jsx(Box, { sx: checkboxContainer, children: checkboxItems.map(function (item) { return (_jsxs(Box, { sx: checkboxItemContainer, children: [_jsx(Checkbox, { sx: checkBoxSx, defaultChecked: true, disabled: true }), _jsx(Typography, { variant: "text-xs-regular", color: function (theme) { return theme.backrs.colors['Colors/Base/Black']; }, children: item })] }, item)); }) })] })] }));
}
var checkBoxSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        '&.Mui-checked .MuiSvgIcon-root': {
            color: backrs.colors['Brand/500'],
            outline: "1px solid ".concat(backrs.colors['Colors/Base/Black']),
            outlineOffset: '-4px',
            borderRadius: backrs.spacing['spacing-sm'],
        },
        paddingTop: 0,
        marginTop: 0,
    });
};
var checkboxItemContainer = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
};
var checkboxContainer = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: backrs.spacing['spacing-lg'],
    });
};
var cardContainer = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        minWidth: {
            xs: '100%',
            md: "calc(50% - ".concat(backrs.spacing['spacing-4xl'], ")"),
        },
        maxWidth: {
            xs: '100%',
            md: "calc(50% - ".concat(backrs.spacing['spacing-4xl'], ")"),
        },
        flexDirection: 'column',
        alignItems: 'center',
        borderRadius: backrs.radius['radius-xl'],
        border: "1px solid ".concat(backrs.colors['Colors/Base/Black']),
        background: backrs.colors['Colors/Background/bg-primary'],
    });
};
var contentContainer = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        padding: "".concat(backrs.spacing['spacing-3xl'], " ").concat(backrs.spacing['spacing-3xl'], " ").concat(backrs.spacing['spacing-3xl']),
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: backrs.spacing['spacing-xl'],
    });
};
var cardTopSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        width: '100%',
        border: "1px solid ".concat(backrs.colors['Colors/Base/Black']),
        bgcolor: backrs.colors['OrangeDark/500'],
    });
};
var cardTitleContainer = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: backrs.spacing['spacing-xs'],
    });
};
var headerImageSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: backrs.spacing['spacing-lg'],
    });
};
